import { Platform } from 'react-native';

/**
 * Converts plain text quotes and dashes into “smart” typography:
 * - Straight single quotes → curly opening (‘) or closing (’) quotes
 * - Straight double quotes → curly opening (“) or closing (”) quotes
 * - Double hyphens (--) → em-dash (—)
 */
export const smartText = (text: string): string =>
  text
    // Match a `'` that comes after start of string, whitespace, dash, em-dash, opening bracket, or quote
    // Replace it with a LEFT SINGLE QUOTATION MARK (‘, U+2018)
    .replace(/(^|[-\u2014\s(["])'/g, '$1\u2018')
    // Replace any remaining straight single quotes with RIGHT SINGLE QUOTATION MARK (’, U+2019)
    .replace(/'/g, '\u2019')
    // Match a `"` that comes after start of string, whitespace, dash, em-dash, opening bracket, or opening single quote
    // Replace it with a LEFT DOUBLE QUOTATION MARK (“, U+201C)
    .replace(/(^|[-\u2014\/[(\u2018\s])"/g, '$1\u201c')
    // Replace any remaining straight double quotes with RIGHT DOUBLE QUOTATION MARK (”, U+201D)
    .replace(/"/g, '\u201d')
    // Replace two consecutive hyphens (--) with an EM DASH (—, U+2014)
    .replace(/--/g, '\u2014');

export const str = {
  apos: '’',
  dQuote: (text: string) => `“${text}”`,

  sharedownload: (text: string) => {
    return (Platform.OS === 'web' ? 'Download ' : 'Share ') + text;
  },

  checklistItemSetupExplanationShort:
    'Checklist items are statements answered with a positive tick or a negative cross',
  checklistItemSetupTitleFieldExample: 'E.g. All doors are locked',
};

str.checklistItemSetupTitleFieldExample = `${str.checklistItemSetupExplanationShort}. ${str.checklistItemSetupTitleFieldExample}`;
